import { Loader2 } from "lucide-react";

export function PageLoader() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Loader2 className="size-8 animate-spin text-[#e8822e]" />
    </div>
  );
}
